import React, { Component } from 'react';
// import logo from '../assets/mb-logo.png';
// import logo1MIN from '../assets/mb_login_image_1_min.jpg';
import logo from '../assets/mb-logono plus.png';
import logo1MIN from '../assets/Mask Group 26@3x.png';
import logo2MIN from '../assets/mb_login_image_2_min.jpg';
import logo3MIN from '../assets/mb_login_image_3_min.jpg';
import { axiosFinal } from '../plugins/axios';
import { USER, Roles } from '../constants/insurance/constant';
import auth from '../auth/auth';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import CloseIcon from '@mui/icons-material/Close';
import { cleverTap } from '../services/provider/common';
import { CLEVER_TAP_EVENTS } from '../constants/provider/constant';
import { toast } from "react-toast";
import { Box, Button, Modal, Typography } from '@mui/material';
import '../style/otpVerificationScreen.css'
import { locationServiceMap, validServices } from './common';

class SignUp extends Component {

  constructor(props) {
    super(props);
    this.otpFieldsRef = [];
    this.state = {
      items: [
        { img: logo1MIN },
        { img: logo2MIN },
        { img: logo3MIN }
      ],
      errors: {
        email: true
      },
      showMessage: null,
      showLoginDisabled: true,
      showForgotDialogBox: false,
      accessToken: props.match.params.token ? props.match.params.token : null,
      id: props.match.params.id ? props.match.params.id : null,
      tokenExpired: false,
      otp: '',
      userId: '',
      userEmail: null,
      isWrongOTP: false,
      errorMessage: null,
      isSubmitting: false,
      showOTPScreen: false,
      encryptionToken: null,
      otpValues: ['', '', '', '', '']
    }
  }

  componentDidMount(){
    if(localStorage.getItem("tokenExpired")){
      toast.error("Session is expired, Login again to continue")
      localStorage.removeItem("tokenExpired");
      localStorage.getItem("access_token") ?? localStorage.removeItem("access_token");
    }
    if(this.state.accessToken)
      this.login();
    cleverTap(CLEVER_TAP_EVENTS.loginVisited,{srcPage:"Login Page"})
  }
  
  handleForgotPassDialogBox(value){
    this.setState({
      showForgotDialogBox : value
    })
  }

  setStateCredentials(emailValue) {
    this.setState({
      ...this.state,
      errors: {
        email: emailValue,
      },
      showLoginDisabled: false
    })
  }

  checkCredentials = (event) => {
    var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
    if (!pattern.test(event.target.value)) {
      this.setStateCredentials(false);
    } else {
      this.setStateCredentials(true);
    }
  }

  handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    this.login(data)
  };

  returnRole(roleId){
    switch(roleId){
      case 5432 : return 'dcadmin';
      case 5433 : return 'dcoperations';
      case 9207 : return 'insureradmin';
      case 9211 : return 'insureragent';
      case 9214 : return 'insurerbranch';
      case 9217 : return 'mareport';
      case 9219 : return 'insurercallCentre';
      default : return null;
    }
  }
  
  checkRoleId(users){
    let role = this.returnRole(users.roleId);
    if(role == null && users.rolesFeatures && users.rolesFeatures.roles){
       users.rolesFeatures.roles.forEach(elem =>{
         if(this.returnRole(elem.roleId) != null && role == null){
          role = this.returnRole(elem.roleId);
        }
      })
      return role;
    }else{
      return role;
    }
  }

  closeOTPModal = () => {
    this.setState({
      otp: '',
      isWrongOTP: false,
      errorMessage: null,
      isSubmitting: false,
      showOTPScreen: false,
      otpValues: ['', '', '', '', '']
    });
  }

  handleOTPChange = (index, value) => {
    // validations
    const numericPattern = /^[0-9]*$/;
    if (value.length > 1 || !numericPattern.test(value)) {
      return; 
    }

    if(this.state.isWrongOTP) {
      this.setState({
        isWrongOTP: false,
        errorMessage: null
      });
    }

    const newOtpValues = [...this.state.otpValues];
    newOtpValues[index] = value.split(" ").join("");
 
    this.setState({ 
      otp: newOtpValues.join(''),
      otpValues: newOtpValues
    });

    if (value.length === 1 && index < this.state.otpValues.length - 1) {
      this.otpFieldsRef[index + 1].focus();
    }
  };

  handleBackspace = (index) => {
    if(this.state.isWrongOTP) {
      this.setState({
        isWrongOTP: false,
        errorMessage: null
      });
    }

    if (this.state.otpValues[index] !== '') {
      const newOtpValues = [...this.state.otpValues];
      newOtpValues[index] = '';

      this.setState({ 
        otp: newOtpValues.join(''),
        otpValues: newOtpValues
      });

    } else if (index > 0) {
      this.otpFieldsRef[index - 1].focus();
    }
  };


  login(data){
    const that = this;
    let roleName = null;
    let authenticateAPIRequestBody;
    let url = window.location.hostname.includes('-stage') || 
              window.location.hostname.includes("localhost") ? 
              "https://providernode.mbstg.in/" : "https://providercore.medibuddy.in/";

    let route = url + 'provider/Authenticate';
    cleverTap(CLEVER_TAP_EVENTS.loginAttempted, {
      srcPage: "/login"
    });

    if (data) {
      authenticateAPIRequestBody = {
        userName: data.get('email'),
        applicationId: this.checkInsurer() ? 100051 : 10007,
        password: data.get('password')
      };
    } else {
      if (this.state.accessToken) {
        authenticateAPIRequestBody = {
          accessToken: this.state.accessToken,
          fromOldPortal: true,
          providerId: this.state.id,
        };
      }
    }

    axiosFinal.post(route, authenticateAPIRequestBody)
      .then(function (response) {
        if (response.data?.isAuthenticated) {

          if(response.data.isOtpNeeded === undefined){
            throw new Error();
          } else if(response.data.isOtpNeeded) {
            if(!response.data.isSuccess) {
              throw new Error();
            }

            that.setState({
              showOTPScreen: true,
              userId: data ? data.get('email') : '',
              // userDetails: response.data?.userDetails ? response.data.userDetails : null,
              encryptionToken: response.data?.accessToken ? response.data.accessToken : '',
              userEmail: response.data?.otpSentOn ? response.data.otpSentOn : 'Registered EmailId'
            });
          } else if(!response.data.isOtpNeeded) {
            toast.success("Logged in Successfully.")
            that.setState({
              showMessage: null
            }, () => {
              auth.login(() => {
                let user_details = response.data.userDetails;
                let hosp_details = response.data.hospDetails;
                roleName = that.checkRoleId(user_details);
                user_details.roleId = Roles[roleName];
                user_details.entityName = hosp_details?.hospName || user_details.firstName + ", " + user_details.lastName;

                USER.user = user_details;
                localStorage.setItem("roleName", roleName);
                localStorage.setItem("user_details", JSON.stringify(user_details));
                localStorage.setItem("access_token", JSON.stringify(response.data.accessToken));

                let location;
                validServices().then(function (response) {
                  localStorage.setItem("ValidServices", JSON.stringify(response.data.validServices))
                  if(!response.data.validServices?.length) {
                    localStorage.setItem("serviceSelected", "LABS");
                    location = locationServiceMap(roleName, "LABS");
                  }
                  else if(response.data.validServices.includes("LABS")) {
                    localStorage.setItem("serviceSelected", "LABS");
                    location = locationServiceMap(roleName, "LABS");
                  } else {
                    localStorage.setItem("serviceSelected", response.data.validServices[0])
                    location = locationServiceMap(roleName, response.data.validServices[0]);
                  }
                  that.props.history.push(location);
                }).catch(function(error) {
                  console.log(error);
                  localStorage.setItem("serviceSelected", "LABS")
                  location = locationServiceMap(roleName, "LABS");
                  that.props.history.push(location);
                });

                cleverTap(CLEVER_TAP_EVENTS.loginSuccess,{
                  ProviderId: user_details.providerId,
                  platform: "web",
                  Message: "Success",
                  isSuccess: 1
                });
                window.clevertap.profile.push(user_details);
              });
            })
          }

        } else if (!response.data?.isAuthenticated) {
          cleverTap(CLEVER_TAP_EVENTS.loginFailed, {
            isSuccess: 0,
            srcPage: "Login",
            srcType: "Web/mWeb",
            ErrorMessage: "You don't have access to Login",
            failureReason: "Login failed",
          });
          toast.error(`Authentification Failed: ${response && response.data && response.data.errorMessage ? response.data.errorMessage.replaceAll("_", " ") : "You don't have access to Login"}`)
        } else {
          toast.error("Unable to login");
          cleverTap(CLEVER_TAP_EVENTS.loginFailed, {
            srcType: "Web/mWeb",
            ErrorMessage: "You don't have access to Login",
            srcPage: "Login",
            isSuccess: 0,
            failureReason: "Login failed",
          });  
        }
      }).catch(function (error) {
        toast.error("Unable to login");
        cleverTap(CLEVER_TAP_EVENTS.loginFailed, {
          isSuccess: 0,
          srcPage: "Login",
          srcType: "Web/mWeb",
          ErrorMessage: "Failure in Authenticate Api",
          failureReason: "Login failed",
        });
      });
  }

  carouselBg() {
    return (
      <Carousel
        autoPlay={true}
        interval={5000}
        showIndicators={true}
        showArrows={true}
        transitionTime={2000}
        infiniteLoop={true}
        autoFocus={false}
        showThumbs={false}
        stopOnHover={false}
      >
        {
          this.state.items.map((item, i) => (
            <div key={i} className="flex justify-center w-full">
              <img className="rounded w-full" src={item.img} alt="logo of provider"></img>
            </div>
          ))
        }
      </Carousel>
    )
  }
  
  checkInsurer = () => {
    return ['ins-stage.medibuddy.in', 'ins.medibuddy.in'].includes(window.location.host)
  }

  verifyOTP = () => {
    const that = this;
    that.setState({
      isSubmitting: true
    });

    let roleName = null;
    let url = window.location.hostname.includes('-stage') || 
              window.location.hostname.includes("localhost") ? 
              "https://providernode.mbstg.in/" : "https://providercore.medibuddy.in/";

    let route = url + 'provider/verifyOTP';
    cleverTap(CLEVER_TAP_EVENTS.otpVerificaiton, {
      srcPage: "/login"
    });

    const verifyOTPAPIRequestBody = {
      otp: that.state.otp,
      applicationId: this.checkInsurer() ? 100051 : 10007,
      userId: that.state.userId,
      encryptedToken: that.state.encryptionToken,
    };

    axiosFinal.post(route, verifyOTPAPIRequestBody)
      .then(function (response) {
        if (response.data?.success) {
          that.setState({
            isSubmitting: false,
            showOTPScreen: false,
          });
          toast.success("Logged in Successfully.");

          that.setState({
            showMessage: null
          }, () => {
            auth.login(() => {
              let user_details = response.data.userDetails;
              let hosp_details = response.data.hospDetails;
              roleName = that.checkRoleId(user_details);
              user_details.roleId = Roles[roleName];
              user_details.entityName = hosp_details?.hospName || user_details.firstName + ", " + user_details.lastName;

              USER.user = user_details;
              localStorage.setItem("roleName", roleName);
              localStorage.setItem("user_details", JSON.stringify(user_details));
              localStorage.setItem("access_token", JSON.stringify(response.data.accessToken));

              let location;
              validServices().then(function (response) {
                localStorage.setItem("ValidServices", JSON.stringify(response.data.validServices))
                localStorage.setItem("serviceSelected", response.data.validServices[0])
                location = locationServiceMap(roleName, response.data.validServices[0]);
                that.props.history.push(location);
              }).catch(function(error) {
                console.log(error);
                localStorage.setItem("serviceSelected", "LABS")
                location = "/"+roleName+"/appointments";
                that.props.history.push(location);
              });

              cleverTap(CLEVER_TAP_EVENTS.loginSuccess,{
                ProviderId: user_details.providerId,
                platform: "web",
                Message: "Success",
                isSuccess: 1
              });
              window.clevertap.profile.push(user_details);
            });
          })
        } else{
          that.setState({
            isWrongOTP: true,
            isSubmitting: false,
            errorMessage: 'Something went wrong please try again'
          });
          toast.error("Unable to login");
          cleverTap(CLEVER_TAP_EVENTS.loginFailed, {
            srcType: "Web/mWeb",
            ErrorMessage: "You don't have access to Login",
            srcPage: "Login",
            isSuccess: 0,
            failureReason: "Login failed",
          });
        }
      })
      .catch(function (error) {
        error?.response?.data?.error ? 
        toast.error("Authentification Failed") :
        toast.error("Unable to login");

        that.setState({
          isWrongOTP: true,
          isSubmitting: false,
          errorMessage: error?.response?.data?.error ? 
          (error.response.data.error).replace(/_/g, ' ') : 
          'Something went wrong please try again!'
        });
        
        cleverTap(CLEVER_TAP_EVENTS.loginFailed, {
          srcPage: "Login-OTP-Verification",
          srcType: "Web/mWeb",
          ErrorMessage: error?.response?.data?.error  ? 
          error.response.data.error : 
          "Failure in verify otp api",
          failureReason: error?.response
        });
      });
  }

  render() {
    if (localStorage.getItem('access_token')) {
      this.props.history.push("/" + localStorage.getItem("roleName") + "/appointments");
    }
    // login-back bg-no-repeat bg-cover bg-right
    return (
      <div className="flex justify-center space-x-0 md:space-x-0 bg-gradient-to-l from-gray-900 via-red-900 to-gray-900">
        <div className="invisible w-0 md:visible md:w-6/12 lg:w-8/12  block m-auto ml-14 white-shadow sm:my-15 ml-0">
          {this.carouselBg()}
        </div>

        <div className="w-full md:w-6/12 lg:w-4/12">
          <div className="flex flex-col h-screen">
            <div className="grid place-items-center my-10 lg:pl-10 sm:my-15 mr-14 my-auto">

              <div className="w-11/12 sm:w-11/12 p-10 md:w-6/12 lg:w-11/12 :w-4/12 px-6 py-10 sm:px-10 sm:py-6 bg-white rounded-lg shadow-md lg:shadow-lg">
                <div className="flex">
                  <div className="w-15-per my-auto">
                    <img src={logo} alt="logo of provider"></img>
                  </div>
                  <div className="text-lg font-semibold pl-2">
                    <span className="text-mb-blue">Medi</span>
                    <span className="text-mb-red">Buddy</span>
                    <br></br>
                    {
                      !this.checkInsurer() ?
                        <React.Fragment>
                          <span className="text-mb-red">Provider</span>
                          <span className="text-mb-blue">Central</span>
                        </React.Fragment>
                        :
                        <React.Fragment>
                          <span className="text-mb-red">Insur</span>
                          <span className="text-mb-blue">ance</span>
                        </React.Fragment>
                    }
                  </div>
                </div>
                  
                <form className="mt-10" method="POST" onSubmit={(e) => this.handleSubmit(e)}>
                  <label htmlFor="email" className="block text-xs font-semibold text-gray-600 uppercase">Username</label>
                  <input 
                    id="email" 
                    type="text" 
                    name="email" 
                    placeholder="username"
                    autoComplete="text"
                    onChange={(e) => this.checkCredentials(e)}
                    className="block w-full py-3 px-1 mt-2 
                    text-gray-800 appearance-none 
                    border-b-2 border-gray-100
                    focus:text-gray-500 focus:outline-none focus:border-gray-200"
                    required 
                  />

                  <label htmlFor="password" className="block mt-2 text-xs font-semibold text-gray-600 uppercase">Password</label>
                  <input 
                    id="password" 
                    type="password" 
                    name="password" 
                    placeholder="password" 
                    autoComplete="current-password"
                    className="block w-full py-3 px-1 mt-2 mb-4
                    text-gray-800 appearance-none 
                    border-b-2 border-gray-100
                    focus:text-gray-500 focus:outline-none focus:border-gray-200"
                    required 
                  />

                  <button
                    className={"w-full py-3 mt-2 bg-mb-btn-color rounded-sm font-medium text-white uppercase cursor-pointer  focus:outline-none hover:bg-gray-700 hover:shadow-none " + (this.state.showLoginDisabled ? 'text-white opacity-50 cursor-not-allowed' : 'text-white opacity-100 cursor-pointer')}
                    disabled={this.state.showLoginDisabled}
                  >
                    Login
                  </button>

                  {/* verify otp popup screen */}
                  <Modal
                    open={this.state.showOTPScreen}
                    onClose={null}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <Box sx={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      width: 'auto',
                      bgcolor: 'background.paper',
                      border: '1px solid #000',
                      borderRadius: '20px',
                      boxShadow: 24,
                      p: 4,
                    }}>
                      <div 
                        style = {{
                          display: 'flex', 
                          justifyContent: 'space-between'
                        }}
                      >
                        <Typography id="modal-modal-title">
                          <span style={{color: '#828282', fontFamily: 'Nunito'}}>Enter: </span> 
                          <span style={{fontWeight: '700', fontFamily: 'Nunito'}}>{this.state.otpValues.length} digit OTP</span>
                        </Typography>
                        <div className="text-gray-500" onClick={this.closeOTPModal}>
                          <span className="cursor-pointer">
                            <CloseIcon></CloseIcon>
                          </span>
                        </div>
                      </div>

                      <div>
                        <Typography id="modal-modal-title">
                          <span style={{color: '#828282', fontFamily: 'Nunito'}}>Sent on: </span> 
                          <span style={{fontWeight: '700', fontFamily: 'Nunito'}}>{this.state.userEmail}</span>
                        </Typography>
                      </div>

                      <div className="otp-container">
                        {
                          this.state.otpValues.map((value, index) => (
                            <input
                              key={index}
                              type="tel"
                              maxLength="1"
                              className={ this.state.isWrongOTP ? "wrongOTP" : "otp-input" }
                              value={value}
                              // pattern="[1-9]{5}"
                              onChange={(e) => this.handleOTPChange(index, e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === 'Backspace') {
                                  this.handleBackspace(index);
                                }
                              }}
                              ref={(ref) => {
                                this.otpFieldsRef[index] = ref;
                              }}
                            />
                          ))
                        }
                      </div>
                      {
                        this.state.errorMessage ?
                        <span
                          style={{
                            fontSize: '12px',
                            color: 'red',
                            fontFamily: 'Nunito'
                          }}
                        >
                          { this.state.errorMessage }
                        </span> : null
                      }

                      <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                        <span 
                          style = {{ 
                            color: '#828282',
                            fontSize: '14px',
                            fontFamily: 'Nunito'
                          }}
                        >
                          The OTP has been shared on your Email ID.<br></br>
                          Please enter the OTP to proceed.
                        </span>
                      </Typography>

                      <Button
                        style={{
                          height: '48px',
                          marginTop: '20px',
                          borderRadius: '16px',
                          backgroundColor: 
                          this.state.otp.length !== this.state.otpValues.length ||
                          this.state.isWrongOTP || 
                          this.state.isSubmitting ? 
                          '#00000042' : '#1778f2',
                        }}
                        onClick={this.verifyOTP}
                        className={"w-full py-3 mt-2 bg-mb-btn-color rounded-sm font-medium text-white uppercase cursor-pointer  focus:outline-none hover:bg-gray-700 hover:shadow-none " + (this.state.showLoginDisabled ? 'text-white opacity-50 cursor-not-allowed' : 'text-white opacity-100 cursor-pointer')}
                        disabled={ 
                          this.state.otp.length !== this.state.otpValues.length ||
                          this.state.isWrongOTP ||
                          this.state.isSubmitting ? 
                          true : false
                        }
                      >
                        <span
                          style={{
                            fontFamily: 'Nunito',
                            color: '#fff',
                            fontWeight: '400',
                            fontSize: '14px',
                          }}
                        >
												  {(this.state.isSubmitting) ? "Verifying..." : "Verify OTP"}
                        </span>
                      </Button>
                    </Box>
                  </Modal>

                  {
                    !this.state.showForgotDialogBox && <div className="text-center pt-2">
                      <span className="text-mb-blue text-xs font-semibold cursor-pointer" onClick={() => this.handleForgotPassDialogBox(true)}>Forgot Password ?</span>
                    </div>
                  }

                  {
                    this.state.showForgotDialogBox &&
                    <div className="head-tag-background-active rounded-md mt-2">
                      <div className="relative py-2 w-full" onClick={() => this.handleForgotPassDialogBox(false)}>
                        <div className="absolute right-0.5 text-xs cursor-pointer text-gray-700">
                          <CloseIcon style={{ fontSize: '18px' }}></CloseIcon>
                        </div>
                      </div>

                      <div className="text-md font-semibold w-full px-2">
                        <div className="text-center">
                          {/* 9606583665 */}
                          8951902958
                        </div>
                      </div>
                      <div className="text-xs text-center px-2 pb-2">
                        Please call us, our executive will assist you in recovering your password
                      </div>
                    </div>
                  }

                  <div className="text-center pt-5">
                    <p className="text-red-500 text-xs italic">{this.state.showMessage}</p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>


      </div>
    );
  }
}

export default SignUp;
